import { CurrencyFormatterUtils } from '../currency-formatter/currency-formatter-utils';
import * as Utils from './prepayment-calculator-utils';

export const actionsTableData = (report, currencyFormatter) => {
    const headers = ['Action Type', 'Prepay Amount'];
    let rows = [];
    if (report && report.reportLoans && report.reportLoans.length > 0) {
        report.reportLoans.forEach(loan => {
            rows.push([
                'Prepay ' + loan.loanType,
                CurrencyFormatterUtils(loan.prepaymentShare, currencyFormatter)
            ]);
        })
    }

    return {
        title: null,
        headers,
        rows,
        editButtonFn: null,
        deleteButtonFn: null,
    }
}

export const actionTableColumns = (currencyFormatter) => [
    {
        field: 'actionType',
        headerName: 'Action Type',
        flex: 1,
        sortable: false
    },
    {
        field: 'prepayAmount',
        headerName: 'Prepay Amount',
        flex: 1,
        sortable: false,
        valueGetter: (params) => params,
        valueFormatter: (params) => `${CurrencyFormatterUtils(params, currencyFormatter)}`,
    },
    {
        field: 'interestSaved',
        headerName: 'Interest Saved',
        flex: 1,
        sortable: false,
        valueGetter: (params) => params,
        valueFormatter: (params) => `${CurrencyFormatterUtils(params, currencyFormatter)}`,
    },
    {
        field: 'originalTenure',
        headerName: 'Old Tenure',
        flex: 1,
        sortable: false,
        valueGetter: (params) => params,
        valueFormatter: (params) => `${params}`,
    },
    {
        field: 'newTenure',
        headerName: 'New Tenure',
        flex: 1,
        sortable: false,
        valueGetter: (params) => params,
        valueFormatter: (params) => `${params}`,
    },
    {
        field: 'tenureVariance',
        headerName: 'Tenure Reduced By',
        flex: 1,
        sortable: false,
        valueGetter: (params) => params,
        valueFormatter: (params) => `${params}`,
    },
];
export const actionTableData = (report) => {
    let formattedData = [];
    if (report && report.reportLoans && report.reportLoans.length > 0) {
        report.reportLoans.forEach(loan => {
            formattedData.push({
                id: Math.random(),
                actionType: 'Prepay ' + loan.loanType,
                prepayAmount: loan.prepaymentShare,
                interestSaved: loan.varianceInterestPayable,
                originalTenure: Utils.formatYearsMonths(loan.originalTenure),
                newTenure: loan.adjustedTenure === 0 ? 'Loan Closed' : Utils.formatYearsMonths(loan.adjustedTenure),
                tenureVariance: Utils.formatYearsMonths(loan.varianceTenure),
            })
        })
    }
    return formattedData;
}


export const getPercentageOfSavingsOnInterest = (report) => {
    let percentageOfTotalSavingsOnInterest = null;
    if (report && report.percentageOfTotalSavingsOnInterest) {
        percentageOfTotalSavingsOnInterest = report.percentageOfTotalSavingsOnInterest + '%';
    }
    return percentageOfTotalSavingsOnInterest;
}
export const getAmountOfSavingsOnInterest = (report) => {
    let totalSavingsOnInterest = null;
    if (report && report.totalSavingsOnInterest) {
        totalSavingsOnInterest = report.totalSavingsOnInterest;
    }
    return totalSavingsOnInterest;
}

export const yourLoansTableData = (loanDetails, currencyFormatter, handleOpenDialog, handleDelete) => {
    const title = loanDetails.loanType;
    const headers = [];
    const rows = [
        ["Outstanding Amount", CurrencyFormatterUtils(loanDetails.outstandingAmount, currencyFormatter)],
        ["Remaining Term", loanDetails.remainingTerm + ' months'],
        ["Interest Rate", loanDetails.interestRate + ' %'],
        ["EMI", CurrencyFormatterUtils(loanDetails.emi, currencyFormatter)],
        ["Interested to prepay loan?", loanDetails.isInterestedInLoanPayment ? 'Yes' : 'No']
    ];
    return {
        title,
        headers,
        rows,
        editButtonFn: () => handleOpenDialog(loanDetails),
        deleteButtonFn: () => handleDelete(loanDetails.id),
    }
}



export const defaultLoansData = [
    {
        id: 54894,
        loanType: "Home Loan",
        outstandingAmount: 6317600,
        remainingTerm: 167,
        interestRate: 8.6,
        emi: 65000,
        isInterestedInLoanPayment: true
    }, {
        id: 30473,
        loanType: "Personal Loan",
        outstandingAmount: 1021800,
        remainingTerm: 175,
        interestRate: 8.6,
        emi: 10265,
        isInterestedInLoanPayment: true
    }
];



export const strategyOptions = [
    { label: 'Pay loans with highest AIPR (Recommended)', value: 'Pay loans with highest AIPR (Recommended)' },
    { label: 'Pay loans with lowest o/s balance', value: 'Pay loans with lowest o/s balance' },
    { label: 'Pay loans with highest interest rate', value: 'Pay loans with highest interest rate' },
];

export const createPrepaymentSplitPieChartData = (reports) => {
    let pieChartData = [];
    if (reports && reports.reportLoans && reports.reportLoans.length > 0) {
        reports.reportLoans.forEach(loan => {
            pieChartData.push({
                id: Math.random(),
                value: loan.prepaymentShare,
                label: loan.loanType
            });
        })
    }
    return pieChartData;

}
